import { css } from "styled-components";

const poppins_heading_base = css`
  font-family: var(--font-poppins);
  font-style: normal;
  font-weight: var(--text-weight-semibold);
`;

export const poppins_heading_xl = css`
  ${poppins_heading_base};
  font-size: var(--text-heading-size-xl);
  line-height: 3.12rem;
  letter-spacing: -0.024rem;
`;

export const poppins_heading_lg = css`
  ${poppins_heading_base};
  font-size: var(--text-heading-size-lg);
  line-height: 2.6rem;
  letter-spacing: -0.02rem;
`;

export const poppins_heading_md = css`
  ${poppins_heading_base};
  font-size: var(--text-heading-size-md);
  line-height: 2.34rem;
  letter-spacing: -0.018rem;
`;

export const poppins_heading_sm = css`
  ${poppins_heading_base};
  font-size: var(--text-heading-size-sm);
  line-height: 2.08rem;
  letter-spacing: -0.016rem;
`;
